<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="value.parameter1"
          filled
          hide-details
          label="Message Type"
          :items="['text', 'object']"
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="value.parameter2"
          label="Send to Current User"
          hide-details
        />
      </v-col>
      <v-col cols="12">
        <ServerTextEditor
          v-model="value.parameter3"
          title="Recipient Username"
        />
      </v-col>
      <v-col cols="12">
        <ServerTextEditor
          v-model="value.parameter4"
          title="Message (for text type)"
        />
      </v-col>
      <v-col cols="12">
        <ServerValueListEditor
          title="Data (for object type)"
          v-model="value.values"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServerTextEditor from "../../ui/shared/ServerTextEditor.vue";
import ServerValueListEditor from "../../ui/shared/ServerValueListEditor.vue";

export default {
  name: "SendMailDesigner",

  components: { ServerTextEditor, ServerValueListEditor },

  props: ["value"],
};
</script>